export default __webpack_public_path__ + "static/atlassian-ai-dark-d5c4d7d64b25a8a6f7ff68e22b27b72c737abbb9248ee3340da552428db254fc.png";